export default {
  Queue: 'Name/Serving number/ID',
  Group: 'Group Name',
  Teacher: 'Teacher Name',
  Other: 'Name/Serving number/ID',
};



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/lookup/component/LookupSearchTitleEnum.js